import universal from 'react-universal-component';

export default universal(() => import('./Auction12'));



// WEBPACK FOOTER //
// ./src/app/views/Auction12/index.js